import { Routes, Route } from "react-router-dom";
import MainContainer from "./layout/MainContainer";
import Pages from "./pages";

const Routing = () => {
  return (
      <Routes>
        <Route path="/" element={<Pages.Login />} />
        <Route path="/forgot-password" element={<Pages.ForgotPassword />} />
        <Route path="/otp" element={<Pages.OtpVerification />} />
        <Route path="/reset-password" element={<Pages.ResetPassword />} />
        <Route element={<MainContainer />}>
        <Route path="/dashboard" element={<Pages.Dashboard />} />
        <Route path="/manage-users" element={<Pages.ManageUser />} />
        <Route path="/manage-users/detail" element={<Pages.ManageUserDetail />} />
        <Route path="/manage-users/edit" element={<Pages.Edituser />} />
        <Route path="/manage-users/add" element={<Pages.Edituser />} />
        <Route path="/manage-subadmin" element={<Pages.ManageSubadmin />} />
        <Route path="/manage-subadmin/add" element={<Pages.AddSubadmin />} />
        <Route path="/manage-subadmin/detail" element={<Pages.SubadminDetail />} />
        <Route path="/manage-subadmin/roles" element={<Pages.ManageSubadminRoles />} />
        <Route path="/manage-subadmin/roles/add" element={<Pages.AddRole />} />
        <Route path="/manage-subadmin/roles/detail" element={<Pages.RoleDetail />} />
        <Route path="/manage-notifications" element={<Pages.ManageNotifications />} />
        <Route path="/manage-notifications/add" element={<Pages.AddNotification />} />
        <Route path="/manage-notifications/detail" element={<Pages.NotificationDetail />} />
        <Route path="/recieved-notifications" element={<Pages.RecievedNotifications />} />
        <Route path="/manage-system-settings" element={<Pages.ManageSystemSettings />} /> 
        <Route path="/manage-system-settings/add-email-template" element={<Pages.AddEmailTemplate />} />
        <Route path="/manage-cms" element={<Pages.ManageCms />} />
        <Route path="/manage-profile" element={<Pages.ManageProfile />} />
        <Route path="/manage-profile/edit" element={<Pages.EditProfile />} />
        <Route path="/manage-profile/change-password" element={<Pages.ChangePassword />} />
        <Route path="/manage-promotions" element={<Pages.ManagePromotion />} />
        <Route path="/manage-promotions/add" element={<Pages.AddPromotion />} />
        <Route path="/manage-promotions/edit" element={<Pages.AddPromotion />} />
        <Route path="/manage-promotions/view" element={<Pages.ViewPromotion />} />
        <Route path="/manage-stores" element={<Pages.ManageStores />} />
        <Route path="/manage-stores/add" element={<Pages.AddStore />} />
        <Route path="/manage-stores/detail" element={<Pages.StoreDetail />} />
        <Route path="/manage-qr-code" element={<Pages.ManageQrCode />} />
        <Route path="/manage-rewards" element={<Pages.ManageRewards />} />
        <Route path="/manage-rewards/add" element={<Pages.AddRewards />} />
        <Route path="/manage-rewards/detail" element={<Pages.RewardsDetail />} />
        <Route path="/manage-transactions" element={<Pages.ManageTransction />} />
        <Route path="/manage-transactions/view" element={<Pages.ViewTransction />} />
        <Route path="/manage-activity-logs" element={<Pages.ManageActivityLogs />} />
        <Route path="/manage-feedback-and-reports" element={<Pages.ManageFeedbackReports />} />
        <Route path="/manage-readymade-yoghurt" element={<Pages.ManageReadyMadeYoghurt />} />
        <Route path="/manage-readymade-yoghurt/add" element={<Pages.AddReadyMadeYoghurt />} />
        <Route path="/manage-readymade-yoghurt/view" element={<Pages.ViewReadyMadeYoghurt />} />
        <Route path="/manage-toppings" element={<Pages.ManageToppings />} />
        <Route path="/manage-product-categories" element={<Pages.ManageProductCategories />} />
        <Route path="/manage-order" element={<Pages.OrderManagement />} />
        <Route path="/manage-order/view" element={<Pages.ViewOrder />} />
        <Route path="/customer-support" element={<Pages.CustomerSupport />} />
        <Route path="/manage-ratings" element={<Pages.Ratings />} />
        <Route path="/revenue-analytic" element={<Pages.RevenueAnalytic />} />
        <Route path="/manage-loyality-points" element={<Pages.LoyaltyPoints />} />
        <Route path="/manage-loyality-points/add" element={<Pages.AddLoyalty />} />
        <Route path="/manage-flavour" element={<Pages.ManageFlavor />} />
        <Route path="/manage-flavour/quantity" element={<Pages.ManageFlavorQuantity />} />
        <Route path="/Manage-Workout" element={<Pages.ManageWorkout />} />
        <Route path="/Manage-Workout/add" element={<Pages.AddDriver />} />
        <Route path="/Manage-Workout/view" element={<Pages.ViewDriver />} />
        <Route path="/manage-programs" element={<Pages.ManageDispatcher />} />
        <Route path="/manage-programs/add" element={<Pages.AddDispatcher />} />
        <Route path="/manage-programs/edit" element={<Pages.EditProgram />} />
        <Route path="/manage-programs/view" element={<Pages.ViewProgram />} />
        <Route path="/discounts" element={<Pages.DiscountCoupon />} />
        <Route path="/discounts/add" element={<Pages.AddDiscount />} />
        <Route path="/discounts/view" element={<Pages.ViewDiscount />} />
        <Route path="/achievements" element={<Pages.ManageBadges />} />
        <Route path="/achievements/add" element={<Pages.EditBadge />} />
        <Route path="/achievements/edit" element={<Pages.EditBadge />} />
        <Route path="/achievements/view" element={<Pages.ViewBadge />} />
        <Route path="/Community" element={<Pages.ManageCommunityGroups />} />
        <Route path="/Community/add" element={<Pages.AddCommunityGroup />} />
        <Route path="/Community/view" element={<Pages.ViewCommunityGroup />} />
        <Route path="/Community/edit" element={<Pages.AddCommunityGroup />} />
        <Route path="/subscription" element={<Pages.Subscriptions />} />
        <Route path="/subscription/view" element={<Pages.ViewSubscription />} />
        <Route path="/subscription/edit" element={<Pages.EditSubscription />} />
        <Route path="/manage-categories" element={<Pages.ManageCategories />} />
        <Route path="/manage-categories/manage-sub-categories" element={<Pages.ManageSubCategories />} />
        <Route path="/manage-categories/manage-attributes" element={<Pages.ManageAttributes />} />
        <Route path="/manage-yogurt-types" element={<Pages.ManageYogurtType />} />
        <Route path="/manage-yogurt-types/detail" element={<Pages.YogurtTypeDetail />} />
        <Route path="/manage-products" element={<Pages.ManageProducts />} />
        <Route path="/manage-products/detail" element={<Pages.ManageProductsDetail />} />
        <Route path="/manage-box-art" element={<Pages.ManageBoxArt />} />
        <Route path="/manage-greek-box" element={<Pages.ManageGreekBox />} />
        <Route path="/manage-greek-box/add" element={<Pages.AddGreekBox />} />
        <Route path="/manage-stores/inventory" element={<Pages.StoreInventory />} />
        <Route path="/settings" element={<Pages.Settings />} />
      </Route>
    </Routes>
  );
};

export default Routing;
